import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Home20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.05624 1.12773C9.57943 0.631293 10.4205 0.631292 10.9437 1.12773C10.9511 1.13477 10.9584 1.14196 10.9656 1.1493L19.538 9.97752L18.4619 11.0225L17.25 9.77442V18C17.25 18.4142 16.9142 18.75 16.5 18.75H3.5C3.08579 18.75 2.75 18.4142 2.75 18V9.77437L1.53804 11.0225L0.461914 9.97752L9.03442 1.1493C9.04155 1.14196 9.04882 1.13477 9.05624 1.12773ZM4.25 8.22963V17.25H7.25V14.7C7.25 13.0722 8.63728 11.75 10.25 11.75C11.8627 11.75 13.25 13.0722 13.25 14.7V17.25H15.75V8.22967L9.99999 2.30813L4.25 8.22963ZM11.75 17.25V14.7C11.75 13.8896 11.0456 13.25 10.25 13.25C9.45444 13.25 8.75 13.8896 8.75 14.7V17.25H11.75Z'
      fill='currentColor'
    />
  </Svg>
);

Home20.displayName = 'Home20';
export default Home20;
